// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_jd-5";
export var filledCircle = "_jd-4";
export var historyEntry = "_jd-3";
export var messageSideLeft = "_jd-1";
export var messageSideRight = "_jd-2";
export var orderTrackingCarouselWrapper = "_jd-6";
export var orderTrackingInfoContainer = "_jd-0";